import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=553a9957&scoped=true&"
import script from "./Verification.vue?vue&type=script&lang=js&"
export * from "./Verification.vue?vue&type=script&lang=js&"
import style0 from "./Verification.vue?vue&type=style&index=0&id=553a9957&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553a9957",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
